module.exports = __webpack_public_path__ + "static/img/phone.377ddbe.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/phone.webp
// module id = urZe
// module chunks = 1